<script>
  import BookmarkTooltip from "@components/BookmarkTooltip.svelte";
  export let data;

  function scrollToBookmark(event){
    event.preventDefault();
    window.noteManager.jumpToNote(data);
  }
</script>

<style type="text/scss">
  .bookmark {
    height: 10px;
    position: absolute;
    top: -12px;
    width: 10px;
    z-index: 10000;
    .hover {
      height: 10px;
      width: 10px;
      i {
        font-size:10px;
        color: #ff6262;
      }
    }
  }
</style>

<div class="bookmark" style="left:calc({data.position}% - 5px)" on:click|preventDefault={scrollToBookmark}>

  <BookmarkTooltip>
    <div class="hover" slot="tooltip">
      <i class="fas fa-bookmark"></i>
    </div>
    <svelte:fragment slot="hover">
      <p>{data.notes}</p>
    </svelte:fragment>
  </BookmarkTooltip>
</div>
